import React, { useState, useEffect } from 'react';
import Modal from '../../common/Modal';
import Input from '../../common/Input';
import Button from '../../common/Button';
import { useToast } from '../../../context/ToastContext';
import { RESOURCE_TYPES } from '../../../utils/constants';
import permissionService from '../../../api/services/permissionService';
import userService from '../../../api/services/userService';
import hostService from '../../../api/services/hostService';
import contestService from '../../../api/services/contestService';
import { handleApiError } from '../../../utils/helpers';
// import Modal from '../common/Modal';
// import Input from '../common/Input';
// import Button from '../common/Button';
// import { useToast } from '../../context/ToastContext';
// import { RESOURCE_TYPES } from '../../utils/constants';
// import permissionService from '../../api/services/permissionService';
// import userService from '../../api/services/userService';
// import hostService from '../../api/services/hostService';
// import contestService from '../../api/services/contestService';
// import { handleApiError } from '../../utils/helpers';

const GrantPermissionModal = ({ onClose, onSuccess }) => {
  const { success, error } = useToast();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [resources, setResources] = useState([]);
  const [formData, setFormData] = useState({
    userId: '',
    resourceType: 'HOST',
    resourceId: '',
    canView: true,
    canCreate: false,
    canEdit: false,
    canDelete: false,
    canManageAll: false
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (formData.resourceType && formData.resourceType !== 'ALL') {
      fetchResources();
    }
  }, [formData.resourceType]);

  const fetchUsers = async () => {
    try {
      const response = await userService.getAllUsers({ role: 'SUB_ADMIN' });
      setUsers(response.data?.users || response.data || []);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  const fetchResources = async () => {
    try {
      let response;
      switch (formData.resourceType) {
        case 'HOST':
          response = await hostService.getMyHosts({ pageSize: 100 });
          setResources(response.data?.hosts || response.data || []);
          break;
        case 'CONTEST':
          response = await contestService.getUserContests({ pageSize: 100 });
          setResources(response.data?.contests || response.data || []);
          break;
        default:
          setResources([]);
      }
    } catch (err) {
      console.error('Error fetching resources:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.userId) {
      error('Please select a user');
      return;
    }

    if (formData.resourceType !== 'ALL' && !formData.resourceId) {
      error('Please select a resource');
      return;
    }

    try {
      setLoading(true);
      const payload = {
        userId: formData.userId,
        resourceType: formData.resourceType,
        resourceId: formData.resourceType === 'ALL' ? null : formData.resourceId,
        canView: formData.canView,
        canCreate: formData.canCreate,
        canEdit: formData.canEdit,
        canDelete: formData.canDelete,
        canManageAll: formData.canManageAll
      };

      await permissionService.grantPermission(payload);
      success('Permission granted successfully');
      onSuccess();
    } catch (err) {
      error(handleApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Grant Permission"
      size="lg"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Select User */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select Sub-Admin
          </label>
          <select
            name="userId"
            value={formData.userId}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            required
          >
            <option value="">Choose a user...</option>
            {users.map(user => (
              <option key={user.id} value={user.id}>
                {user.firstName} {user.lastName} ({user.email})
              </option>
            ))}
          </select>
        </div>

        {/* Select Resource Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Resource Type
          </label>
          <select
            name="resourceType"
            value={formData.resourceType}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            required
          >
            {Object.values(RESOURCE_TYPES).map(type => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Select Specific Resource */}
        {formData.resourceType !== 'ALL' && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select {formData.resourceType}
            </label>
            <select
              name="resourceId"
              value={formData.resourceId}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              required
            >
              <option value="">Choose a {formData.resourceType.toLowerCase()}...</option>
              {resources.map(resource => (
                <option key={resource.id} value={resource.id}>
                  {resource.name || resource.title}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Permissions Checkboxes */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Permissions
          </label>
          <div className="space-y-3">
            <label className="flex items-center">
              <Input
                type="checkbox"
                name="canView"
                checked={formData.canView}
                onChange={handleChange}
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">Can View</span>
            </label>

            <label className="flex items-center">
              <input
                type="checkbox"
                name="canCreate"
                checked={formData.canCreate}
                onChange={handleChange}
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">Can Create</span>
            </label>

            <label className="flex items-center">
              <input
                type="checkbox"
                name="canEdit"
                checked={formData.canEdit}
                onChange={handleChange}
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">Can Edit</span>
            </label>

            <label className="flex items-center">
              <input
                type="checkbox"
                name="canDelete"
                checked={formData.canDelete}
                onChange={handleChange}
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">Can Delete</span>
            </label>

            <label className="flex items-center">
              <input
                type="checkbox"
                name="canManageAll"
                checked={formData.canManageAll}
                onChange={handleChange}
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">
                Can Manage All (Full Access)
              </span>
            </label>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-4">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loading={loading}
          >
            Grant Permission
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default GrantPermissionModal;